// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

import './config/i18n';  // Add this line

// 偵測環境
const isLineApp = /Line/i.test(navigator.userAgent);
const isOldBrowser = !window.Promise || !Object.assign || !Array.prototype.includes;

// 只在真正需要時加入最小的 polyfills
if (isLineApp || isOldBrowser) {
  // Promise polyfill
  if (!window.Promise) {
    window.Promise = Promise;
  }
  
  // Object.assign polyfill
  if (!Object.assign) {
    Object.assign = function(target) {
      'use strict';
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      target = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source != null) {
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
      }
      return target;
    };
  }
  
  // Array.includes polyfill
  if (!Array.prototype.includes) {
    Array.prototype.includes = function(searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var O = Object(this);
      var len = parseInt(O.length, 10) || 0;
      if (len === 0) return false;
      var n = parseInt(fromIndex, 10) || 0;
      var k;
      if (n >= 0) {
        k = n;
      } else {
        k = len + n;
        if (k < 0) k = 0;
      }
      var currentElement;
      while (k < len) {
        currentElement = O[k];
        if (searchElement === currentElement) return true;
        k++;
      }
      return false;
    };
  }
}

// Debug 資訊
if (isLineApp) {
  console.log('[LINE WebView] Detected, applying compatibility mode');
}

// 主要渲染 - REMOVED BrowserRouter since it's already in App.js
try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Render error:', error);
  // 如果失敗，顯示錯誤訊息
  document.getElementById('root').innerHTML = `
    <div style="text-align: center; padding: 40px; font-family: sans-serif;">
      <h2>載入錯誤</h2>
      <p>請重新整理頁面</p>
      <button onclick="location.reload()" style="padding: 10px 20px; margin-top: 20px;">
        重新整理
      </button>
    </div>
  `;
}